import React, { useState } from 'react'
import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from 'react-icons/md'
import { CollapseStyle } from './custom-collapse-style'
import { tagReadFAQ } from '../../utils/lib/events';
interface collapseItem {
    title?: string,
    description?: string,

}
function CustomCollapse({ collapseItems, headerBg,
    bodyBg }: {
        collapseItems: collapseItem[], headerBg?: string,
        bodyBg?: string
    }) {
    const [active, setActive] = useState<number>();

    const handleClick = async(index: number, value: collapseItem) => {
        if(active == index + 1){
            setActive(0);
        }else{
            setActive(index+1);
        }
        await tagReadFAQ(value?.title);
    }

    return (
        <CollapseStyle className='my-5'>
            {collapseItems?.map((value, index) => {
                return (
                    <div key={index} className="collapse-item  my-4">
                        <div className='px-4 py-3 collapse-header cursor-pointer' style={{ backgroundColor: headerBg ? `${headerBg}` : '#f8f8f8' }} onClick={() => handleClick(index, value)} >
                            <div className='d-flex justify-content-between align-items-center'>
                                <p className='mb-0 bold'>{value?.title}</p>
                                {value?.description?.length > 0 && <>{active == index + 1 ?
                                    <MdOutlineKeyboardArrowUp className='text-danger' size={18} />
                                    :
                                    <MdOutlineKeyboardArrowDown className='text-danger' size={18} />
                                }</>}
                            </div>
                        </div>
                        {value?.description?.length > 0 && <div className={`collapse-body ${active == index + 1 ? 'show-collapse' : 'hide-collapse'}`} style={{ backgroundColor: bodyBg ? `${bodyBg}` : '#f8f8f8' }} >
                            <div>
                                <p className={`px-4 py-2 ${active == index + 1 ? 'visible' : 'invisible'}`}>{value?.description}</p>
                            </div>
                        </div>}

                    </div>
                )
            })}
        </CollapseStyle>
    )
}

export default CustomCollapse